<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <BlockUI :loading="block" />
      <!--begin::Card header-->
      <div class="border-bottom">
        <!--begin::Card title-->

        <div class="row ps-8 pe-8 pt-5 pb-5 align-items-center">
          <!--begin::Label-->
          <div class="col-lg-4">
            <h3 class="d-flex flex-column m-0">
              {{ translate("Projects") }}
              <span class="text-muted mt-1 fw-bold fs-7"
                >{{ records }} {{ translate("Records_Found") }}</span
              >
            </h3>
          </div>
        </div>
      </div>

      <div class="card-body pt-6 pb-0">
        <!--begin::Item-->
        <div
          v-for="(project, index) in projectList"
          :key="index"
          class="d-flex align-items-center mb-1 border rounded p-2"
        >
          <!--begin::Bullet-->
          <span
            class="bullet bullet-vertical h-40px"
            :class="`bg-primary`"
          ></span>
          <!--end::Bullet-->

          <!--begin::Description-->
          <div class="flex-grow-1">
            <div class="d-flex flex-column position-relative w-100 ms-5">
              <label
                class="form-check-label col-form-label fw-bold p-0 mt-2"
                style="margin-bottom: 15px"
                >{{ project.Name }}
              </label>
              <label
                class="form-check-label col-form-label fw-bold fs-7 p-0 text-gray-500"
                style="position: absolute; margin-top: 20px"
                >{{ project.CustomerName }}
              </label>
            </div>
          </div>
          <!--end::Description-->
        </div>

        <div class="row pe-8 pt-5 pb-5 align-items-center">
          <div class="col-lg-12">
            <Pagination @onPage="onPage" :TotalData="records" />
          </div>
        </div>
      </div>
    </div>
    <!-- :project="project" -->
  </div>
</template>

<script setup>
import { ref, reactive, inject } from "vue";

import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import UsersModule from "@/store/modules/Users/UsersModule";

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();
const block = ref(true);
const checkAll = ref();
const records = ref(0);
const projectList = ref([]);
const user = inject("user");

// Filter
const filterObject = reactive({
  page: 1,
  pageSize: 10,
  userId: 0,
});

filterObject.userId = user.id;

const onPage = (e) => {
  filterObject.page = e.step.value;
  filterObject.pageSize = e.pageSize.value;

  getProject();
};
// Filter End

const getProject = () => {
  UsersModule.actions
    .GET_USER_PROJECTS(null, filterObject)
    .then((response) => {
      records.value = response.TotalItemsCount;
      projectList.value = response.ListItems;
    })
    .finally(() => (block.value = false));
};

getProject();
</script>

<style scoped>
.border-radius-left {
  border-radius: 5px 0 0 5px !important;
}
.border-radius-right {
  border-radius: 0 5px 5px 0 !important;
}
.select-menu-list {
  right: 0;
  top: 38px;
  width: 200px;
  background-color: #fff;
  padding: 4px 2px 2px 2px;
  z-index: 5;
}
.select-menu-list li {
  list-style-type: none;
  margin-bottom: 2px;
  padding: 4px 2px 4px 5px;
  color: #3f4254;
}
.select-menu-list li:hover {
  background-color: #04c8c8;
  font-weight: 500;
  color: #fff;
}
.select-item {
  background-color: #04c8c8a9;
  color: #fff !important;
  font-weight: 500;
}
.made-enter-active,
.made-leave-active {
  transition: opacity 0.2s ease;
}

.made-enter-from,
.made-leave-to {
  opacity: 0;
}
</style>
